var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mobile ticket icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0Z",
    "data-name": "Path 4544"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9940"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc62d",
    d: "M37.062 16.219V9.406A3.405 3.405 0 0 0 33.656 6H6.406a3.39 3.39 0 0 0-3.389 3.406v6.812A3.407 3.407 0 0 1 3 23.031v6.812a3.416 3.416 0 0 0 3.406 3.406h27.25a3.416 3.416 0 0 0 3.406-3.406v-6.812a3.406 3.406 0 1 1 0-6.812m-3.406-2.487a6.8 6.8 0 0 0 0 11.785v4.326H6.406v-4.326a6.84 6.84 0 0 0 3.406-5.893 6.8 6.8 0 0 0-3.389-5.893l-.017-4.325h27.25Zm-15.328 11h3.406v3.408h-3.406Zm0-6.812h3.406v3.406h-3.406Zm0-6.812h3.406v3.406h-3.406Z",
    "data-name": "Path 4545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e2240",
    d: "M18.328 24.734h3.406v3.406h-3.406Zm0-6.812h3.406v3.406h-3.406Zm0-6.812h3.406v3.406h-3.406Z",
    "data-name": "Path 5936"
  })))));
};
export { SvgTicket as ReactComponent };
export default "/_next/static/images/ticket.svg";